<template>
    <div class="digitalplace">

        <div class="container mobile">

            <div class="row logo-header">
                <span class="partner intel">
                    <img src="/assets/images/icons/intel.svg"/>
                </span>
                <span class="partner computacenter"
                >
                    <img src="/assets/images/icons/compitacenter.svg"/>
                </span>
            </div>

            <div class="environments cards active"
            >
                <!--v-bind:style="[activeCard =='environments' ? {'max-height':heightCard} : {} ]"-->
                <!--v-bind:class="{ active: activeCard =='environments' }"-->
                <div class="rap row">
                    <div class="card"
                    >
                        <!--v-on:click="activatedCard('environments')"-->
                        <h3>Environments</h3>

                    </div>
                </div>
                <div class="details-wrap"
                >
                    <!--v-bind:style="[activeCard =='environments' ? {'max-height':heightCard} : {}]"-->
                    <div class="details row">
                        <div class="col s12"
                             v-for="(item, key) in envList"
                             :key="key"
                        >
                            <div class="item">
                                <div class="text">
                                    <h5>{{item.title}}</h5>
                                    <div class="description">
                                        {{item.description}}
                                    </div>
                                    <div class="link"
                                         v-on:click="setActiveEnv(item.id)"
                                    >
                                        VIEW ENVIRONMENT ››
                                    </div>
                                </div>
                                <div class="img">
                                    <img :src="item.image"/>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="desktop"
             v-bind:class="{ place: !tablePlace}"
        >
            <div class="header">
                <div class="logo-header">
                    <span class="partner intel">
                        <img src="/assets/images/icons/intel.svg"/>
                    </span>
                    <span class="partner computacenter">
                        <img src="/assets/images/icons/compitacenter.svg"/>
                    </span>
                </div>
                <div class="menu"
                     v-bind:class="{table:!tablePlace}"
                     v-on:click="tablePlace = !tablePlace"
                ></div>
            </div>

            <CityPlace
                v-bind:tablePlace="tablePlace"
                v-bind:listEnvParam="listEnvParam"
                v-on:setActiveEnv="setActiveEnv"

            />
            <div class="hiden-preload-image">
                <img
                    v-for="url  in envListImages"
                    :src="url" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    // import M from 'materialize-css'
    import CityPlace from "../components/digitalplace/CityPlace.vue";
    import CityTable from "../components/digitalplace/CityTable.vue";

    export default {
        name: 'Digitalplace',
        props: ['selectEnvironments', 'envListImages'],
        data() {
            return {
                tablePlace: true,
                activeCard: 'environments',
                heightCard: '',
                listEnvParam: {
                    'groupoffice': {
                        left: 1,
                        width: 372,
                    },
                    'home-office': {
                        left: 16,
                        width: 218,
                    },
                    'manufacturing': {
                        left: 25,
                        width: 248,
                    },
                    'logistics-distribution': {
                        left: 35.5,
                        width: 289,
                    },
                    'transport-hub': {
                        left: 48,
                        width: 341,
                    },
                    'health': {
                        left: 63,
                        width: 348,
                    },
                    'data-center': {
                        left: 78,
                        width: 221,
                    },
                    'construction-site': {
                        left: 87,
                        width: 279,
                    },


                    'high-street': {
                        left: 3.5,
                        width: 160,
                    },
                    'groupbank': {
                        left: 12,
                        width: 303,
                    },
                    'department-store': {
                        left: 26,
                        width: 480,
                    },
                    'supermarket': {
                        left: 48,
                        width: 420
                    },
                    'betshop': {
                        left: 67,
                        width: 236,
                    },
                    'phoneshop': {
                        left: 78,
                        width: 253,
                    },
                    'coffee-shop': {
                        left: 89,
                        width: 214,
                    },
                },
            }
        },
        computed: {
            envList: function () {
                let envList = [];
                this.globalData.environments.forEach((item, i) => {
                    // if (this.selectEnvironments.indexOf(item.id) != -1) {
                    //     if (item.slug == 'groupbank') {
                    //         this.globalData.environments.forEach((subEnv, i) => {
                    //             if (subEnv.parent == item.id) {
                    //                 envList.push(subEnv)
                    //             }
                    //         });
                    //     } else {
                    //         envList.push(item)
                    //     }
                    if (item.grouptype) {
                        // this.globalData.environments.forEach((subEnv, i) => {
                        //     if (subEnv.parent == item.id) {
                        //         envList.push(subEnv)
                        //     }
                        // });
                    } else {
                        envList.push(item)
                    }
                    // }
                });
                return envList;
            }
        },
        mounted() {
            this.activatedCard('environments')
            // var elem = document.querySelector('.collapsible');
            // this.inst = M.Collapsible.init(elem);

        },
        methods: {
            setActiveEnv(id) {
                this.$emit('setActiveEnv', id);
                this.$router.push({name: 'Environments'});
            },
            activatedCard(card) {
                if (!this.activeCard || this.activeCard != card) {
                    this.activeCard = card;
                    var elCard = document.querySelectorAll('.' + card + ' .card')[0];
                    var elDetails = document.querySelectorAll('.' + card + ' .details')[0];
                    let height = elCard.offsetHeight + elDetails.offsetHeight + 30;
                    this.heightCard = height + 'px';

                } else {
                    this.activeCard = false;
                }
            },
            myListClass(key) {
                let cl = '';

                if ((key) % 3) {
                    cl = 's6';
                } else {
                    cl = 's12';
                }
                return cl;
            },
        },
        components: {
            CityTable, CityPlace
        }
    }
</script>